import { GeneralModel } from "./general.model";

export class Cod extends GeneralModel {
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/cod.model.ts